/**
 * Lean Mode — עמוד פרופיל חבילה מצומצם לביצועים (ללא מחיקת קוד מלא).
 *
 * הפעלה:
 * - Vite: VITE_HR_DP_LEAN_PROFILE=1 (או "true")
 * - דפדפן: localStorage.setItem(HR_DP_LEAN_PROFILE, "1")
 *
 * הערה: Lean לא מדלג על compact flight snapshot / pricing selection —
 * אחרת טיסות נעלמות אחרי refresh בפרופיל חבילה.
 *
 * @returns {boolean}
 */
export const HR_DP_LEAN_PROFILE = "HR_DP_LEAN_PROFILE";

export function isHrDpLeanProfileEnabled() {
  try {
    const v =
      typeof import.meta !== "undefined" && import.meta.env && import.meta.env.VITE_HR_DP_LEAN_PROFILE;
    const s = v != null ? String(v).trim().toLowerCase() : "";
    if (s === "1" || s === "true" || s === "yes") return true;
    if (
      typeof window !== "undefined" &&
      typeof window.localStorage?.getItem === "function" &&
      window.localStorage.getItem(HR_DP_LEAN_PROFILE) === "1"
    ) {
      return true;
    }
  } catch {
    /* ignore */
  }
  return false;
}

/** לתיעוד / קישור מתי כותבים CONSTANT מקומי */
export const HR_DP_LEAN_PROFILE_ENV_KEY = "VITE_HR_DP_LEAN_PROFILE";
export const HR_DP_LEAN_PROFILE_STORAGE_KEY = HR_DP_LEAN_PROFILE;
